import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  // disable console.log
  window.console.log = () => {};
}

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));
